import React, { FC } from 'react';
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';
import SelectInput from './SelectInput';
import PermitType from '../../../types/permit.type';
import { useTags } from '../../../hooks/useTags';
import formLang from '../../../data/lang/form.lang';




type PermitTypeSelectProps = {
  permitType: PermitType,
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void,
  handleBlur: (e: React.FocusEvent<any>) => void,
}

const PermitTypeSelect: FC<PermitTypeSelectProps> = ({ permitType, handleChange, handleBlur }) => {

  const { projectConfigState } = useProjectConfigContext();
  const projectId = projectConfigState.projectId;


  const generateTag = useTags();

  const permitTypeLabel = generateTag(formLang, 'input-label.permit-type');
  const permitByZoneOption = generateTag(formLang, `permit-type-options.${PermitType.PERMIT_BY_ZONE}`);
  const taxiOption = generateTag(formLang, `permit-type-options.${PermitType.TAXI}`);
  const handicappedOption = generateTag(formLang, `permit-type-options.${PermitType.HANDICAPPED}`);
  const regularOption = generateTag(formLang, `permit-type-options.${PermitType.REGULAR}`);

  const selects = [
    { value: PermitType.PERMIT_BY_ZONE, name: permitByZoneOption },
    { value: PermitType.TAXI, name: taxiOption },
    { value: PermitType.HANDICAPPED, name: handicappedOption },
    { value: PermitType.REGULAR, name: regularOption },
  ]

  if (projectId !== 25) {
    return null;
  }

  return (
    <SelectInput
      label={permitTypeLabel}
      name='permitType'
      value={permitType}
      selects={selects}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

export default PermitTypeSelect;